document.addEventListener("DOMContentLoaded", function () {
  const searchTrigger = document.querySelector('.js-headersearch--trigger');
  const searchPanel = document.querySelector('.js-headersearch--panel');

  const searchTriggerActiveClass = 'c-header__search--active';
  const searchPanelActiveClass = 'c-header__search-panel--active';

  if (searchTrigger && searchPanel) {
    searchTrigger.addEventListener('click', function () {
      if (searchTrigger.classList.contains(searchTriggerActiveClass)) {
        searchTrigger.classList.remove(searchTriggerActiveClass);
      } else {
        searchTrigger.classList.add(searchTriggerActiveClass);
      }
      if (searchPanel.classList.contains(searchPanelActiveClass)) {
        searchPanel.classList.remove(searchPanelActiveClass);
      } else {
        searchPanel.classList.add(searchPanelActiveClass);
      }
    });
  }

  const searchInput = document.querySelector('.js-headersearch--input');
  const searchButton = document.querySelector('.js-headersearch--button');

  if (searchButton && searchInput) {
    const searchUrl = searchButton.getAttribute('data-url');

    searchButton.addEventListener('click', function () {
      if (searchInput.value && searchInput.value.length > 0) {
        window.location.assign(`${searchUrl}?keyword=${searchInput.value}`);
      }
      else {
        window.location.assign(searchUrl);
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.keyCode == 13) {
        if (searchInput.value && searchInput.value.length > 0) {
          window.location.assign(`${searchUrl}?keyword=${searchInput.value}`);
        }
        else {
          window.location.assign(searchUrl);
        }
      }
    });
  }
});